// Leadfeeder-spårning. Får ENDAST laddas efter samtycke (se AnalyticsGate).
const LEADFEEDER_ID = 'JMvZ8gvP1g9a2pOd';
const SCRIPT_ID = 'leadfeeder-tracker';

export function isLeadfeederLoaded() {
  return !!document.getElementById(SCRIPT_ID);
}

export function loadLeadfeeder() {
  if (isLeadfeederLoaded()) return;

  // Samma stub som Leadfeeders egen snippet
  window.ldfdr = window.ldfdr || function () {
    (window.ldfdr._q = window.ldfdr._q || []).push([].slice.call(arguments));
  };

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = `https://sc.lfeeder.com/lftracker_v1_${LEADFEEDER_ID}.js`;
  document.head.appendChild(script);
}
